<template>
    <div class="md:grid md:grid-cols-3 md:gap-6">
        <jet-section-title>
            <template #title><slot name="title"></slot></template>
            <template #description><slot name="description"></slot></template>
        </jet-section-title>

        <div class="mt-5 md:mt-0 md:col-span-2">


            <form :class="hasBadge ? 'relative' : ''" @submit.prevent="$emit('submitted')">
                <div class="shadow overflow-hidden"
                    :class="hasActions ? 'sm:rounded-tl-md sm:rounded-tr-md' : 'sm:rounded-md'">

                    <transition
                        enter-active-class="ease-out duration-300" enter-from-class="h-0" enter-to-class="h-1"
                        leave-active-class="ease-in duration-200" leave-from-class="h-1" leave-to-class="h-0">
                        <working-bar v-if="working"></working-bar>
                    </transition>

                    <div class="px-4 py-5 bg-white sm:p-6 grid grid-cols-6 gap-6">
                        <div v-if="hasBadge" class="absolute top-2 right-2 px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800">
                            <slot name="badge"></slot>
                        </div>
                        <slot name="form"></slot>
                    </div>
                </div>

                <div class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6 shadow sm:rounded-bl-md sm:rounded-br-md" v-if="hasActions">
                    <slot name="actions"></slot>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import JetSectionTitle from './SectionTitle.vue'
    import WorkingBar from "../Components/WorkingBar";

    export default defineComponent({
        emits: ['submitted'],
        props: ['working'],

        components: {
            WorkingBar,
            JetSectionTitle,
        },

        computed: {
            hasActions() {
                return !! this.$slots.actions
            },
            hasBadge() {
                return !! this.$slots.badge
            }
        }
    })
</script>
